import { Container } from '@tencent/alloy-renderer';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { CANVAS_ANIM_WRAPPER } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { IComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-wrapper.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

/**
 * 动画元素wrapper层
 */
export class ComponentAnimWrapper extends Container {
    // 生成图形的入参
    public readonly factoryOptions: InterfaceFactoryOptions<IElementBaseModel>;
    // 整个factory的更新，组合手动刷子元素时需要调用
    public readonly factoryUpdateComponent: () => void;
    // 整个factory的dispose，因为factory没有生命周期，所以需要依赖wrapper
    private readonly factoryDispose: () => void;

    // 获取当前 wrapper component实例（主要是为了解决component-anim-wrapper动态外包一层时获取wrapper麻烦）
    public get wrapperInstance(): IComponentWrapper {
        return this.children[0] as IComponentWrapper;
    }

    public constructor(
        factoryOptions: InterfaceFactoryOptions<IElementBaseModel>,
        factoryDispose: () => void,
        factoryUpdateComponent: () => void,
    ) {
        super();
        this.factoryOptions = factoryOptions;
        this.factoryDispose = factoryDispose;
        this.factoryUpdateComponent = factoryUpdateComponent;
        this.id = `${CANVAS_ANIM_WRAPPER}#${factoryOptions?.model?.key}`;
    }

    public dispose(): void {
        super.dispose();
        this.factoryDispose?.();
    }
}
